import React, { FunctionComponent, ReactNode } from "react";
import MuiCheckbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import { getIn, useField, useFormikContext } from "formik";
import { FormHelperText } from "@material-ui/core";

const useStyles = makeStyles(({ typography }) => ({
  label: {
    fontSize: typography.body2.fontSize,
  },
}));

type IProps = CheckboxProps & {
  label?: ReactNode;
  name: string;
};

export const FormikCheckbox: FunctionComponent<IProps> = ({
  label,
  name,
  disabled = false,
  classes,
  className,
  ...props
}: IProps) => {
  const [field] = useField(name);
  const { isSubmitting, errors, touched } = useFormikContext();
  const customClasses = useStyles();
  const mergedClasses = { ...customClasses, ...classes };

  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;

  const restProps = {
    disabled: isSubmitting || disabled,
    ...props,
    ...field,
    checked: field.value ? true : false,
    value: field.value ? "checked" : "",
  };

  if (label) {
    return (
      <>
        <FormControlLabel
          control={<MuiCheckbox classes={classes} {...restProps} />}
          label={label}
          classes={mergedClasses}
          className={className}
        />
        {showError && (
          <Box mb={1}>
            <FormHelperText error>{fieldError}</FormHelperText>
          </Box>
        )}
      </>
    );
  }

  return <MuiCheckbox classes={classes} {...restProps} />;
};
